/* eslint-disable radix */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import get from 'lodash.get';
import {
    Typography,
    Button,
    Paper,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Chip,
    Grid,
} from '@material-ui/core';
import CancelPresentation from '@material-ui/icons/CancelPresentation';

import { updateDetailSettings } from 'Console/data/applicationDetail/settings/SettingsAction';

import { selectApplicationMetaData } from 'Console/data/applicationDetail/settings/SettingsSelector';

import FormItemSwitch from 'Console/components/common/form/FormItemSwitch';
import FormInput from 'Console/components/common/form/FormInput';

import chemicalBank from 'Console/assets/images/tool.svg';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        padding: '0 24px',
        fontSize: theme.typography.pxToRem(14),
    },
    title: {
        display: 'inline-block',
        'font-weight': 'bold',
        'padding-bottom': theme.typography.pxToRem(20),
    },
    title2: {
        extend: 'title',
        'padding-top': 25,
    },
    title3: {
        extend: 'title',
        'padding-bottom': 0,
        'padding-right': 10,
    },
    message: {
        fontSize: theme.typography.pxToRem(14),
        paddingBottom: theme.typography.pxToRem(25),
    },
    spaceBottom: {
        'padding-bottom': theme.typography.pxToRem(30),
    },
    itemsBox: {
        paddingTop: theme.typography.pxToRem(22),
        paddingBottom: theme.typography.pxToRem(32),
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.between('xs', 'md')]: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
    },
    paper: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        width: '100%',
    },
    tableItem: {
        textAlign: 'right',
    },
    btn: {
        marginTop: theme.typography.pxToRem(20),
        marginBottom: theme.typography.pxToRem(40),
    },
    btnAdd: {
        marginTop: theme.typography.pxToRem(15),
        marginLeft: theme.typography.pxToRem(47),
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },
    subTitleActive: {
        paddingLeft: theme.typography.pxToRem(16),
        paddingRight: theme.typography.pxToRem(18),
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 0,
        },
    },
    img: {
        display: 'inline-block',
        width: theme.typography.pxToRem(8),
        marginLeft: theme.typography.pxToRem(8),
    },
    listItems: {
        paddingTop: theme.typography.pxToRem(20),
        paddingBottom: theme.typography.pxToRem(20),
        width: '100%',
    },
    listItem: {
        padding: 0,
    },
    boxList: {
        width: '39%',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    experimental: {
        fontSize: theme.typography.pxToRem(10),
    },
    formInput: {
        width: '28%',
        [theme.breakpoints.between('xs', 'md')]: {
            width: '100%',
            paddingBottom: theme.typography.pxToRem(20),
        },
    },
    item: {
        paddingBottom: theme.typography.pxToRem(21),
    },
});

class Tracking extends Component {
    handleSaveSettings = () => {
        const {
            updateDetailSettings,
            form: { getFieldValue },
        } = this.props;

        const { enabled, sampleRate, batchInterval, schedule, events } = getFieldValue('tracking');
        const patterns = getFieldValue('patterns');

        updateDetailSettings(
            {
                'metadata.tracking.enabled': enabled,
                'metadata.tracking.sampleRate': parseInt(sampleRate),
                'metadata.tracking.batchInterval': parseInt(batchInterval),
                'metadata.tracking.schedule': schedule || '',
                'metadata.tracking.events.click': events.click,
                'metadata.tracking.events.mousemove': events.mousemove,
                'metadata.tracking.events.scroll': events.scroll,
                'metadata.tracking.events.mousedown': events.mousedown,
                'metadata.tracking.events.mouseup': events.mouseup,
                'metadata.tracking.events.keydown': events.keydown,
                'metadata.tracking.events.keyup': events.keyup,
                'metadata.tracking.whitelist.patterns': patterns || [],
            },
            {
                success: (
                    <FormattedMessage id="Notification.save" defaultMessage="Your settings were saved" />
                ),

                fail: (
                    <FormattedMessage
                        id="Notification.fail"
                        defaultMessage="Unable to save, something went wrong"
                    />
                ),
            }
        );
    };

    handleAddRow = () => {
        const {
            form: { getFieldValue, setFieldsValue },
        } = this.props;

        const pattern = getFieldValue('tracking.pattern');
        const patterns = getFieldValue('patterns');

        setFieldsValue({
            patterns: [...patterns, pattern],
            'tracking.pattern': '',
        });
    };

    handleRemoveItem = (itemToDelete) => {
        const {
            form: { getFieldValue, setFieldsValue },
        } = this.props;

        const patterns = getFieldValue('patterns');

        setFieldsValue({
            patterns: patterns.filter((item) => item !== itemToDelete),
        });
    };

    render() {
        const {
            classes,
            intl,
            form,
            metadata,
            form: { getFieldDecorator, getFieldValue },
        } = this.props;

        getFieldDecorator('patterns', {
            initialValue: get(metadata, 'tracking.whitelist.patterns') || [],
            preserve: true,
        });

        getFieldDecorator('tracking.enabled', {
            initialValue: get(metadata, 'tracking.enabled') || false,
            preserve: true,
        });

        return (
            <Grid className={classes.root}>
                <Grid container alignItems="center" className={classes.item}>
                    <Typography variant="subtitle1" className={classes.title3}>
                        <FormattedMessage
                            id="Settings.tracking.userBehaviour"
                            defaultMessage="User behaviour tracking"
                        />
                    </Typography>

                    <Chip
                        label={intl.formatMessage({ id: 'Settings.tracking.experimental' })}
                        icon={<img className={classes.img} alt="logo" src={chemicalBank} />}
                        className={classes.experimental}
                    />
                </Grid>

                <Grid item>
                    <Typography variant="body1" className={classes.message}>
                        <FormattedMessage
                            id="Settings.tracking.message"
                            defaultMessage="If you want to enable experimental behaviour tracking used for guide generation and user confusion analysis, click Enable button and select tracking options. For events 'keyup' and 'keydown' we do not track the pressed key"
                        />
                    </Typography>
                </Grid>

                <Grid container direction="row" alignItems="center" className={classes.spaceBottom}>
                    <Typography variant="body1" className={classes.subTitleActive}>
                        <FormattedMessage id="Buttons.switchEnable" defaultMessage="Enable" />
                    </Typography>

                    <FormItemSwitch
                        initialValue={get(metadata, 'tracking.enabled')}
                        form={form}
                        formItemKey="tracking.enabled"
                    />
                </Grid>

                {getFieldValue('tracking.enabled') && (
                    <>
                        <Grid item>
                            <Typography variant="body1" className={classes.message}>
                                <FormattedMessage
                                    id="Settings.tracking.message2"
                                    defaultMessage="Default values for sampling rate is 16 (~60fps) and batch interval is 1000 (ms). Set schedule to only track user behaviour in desired time interval. The format of schedule is start-end, where start and end are hours (ie. schedule value 10-14 tracks user activity between 10:00-14:00)"
                                />
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            direction="row"
                            justify="space-around"
                            alignItems="flex-end"
                            className={classes.itemsBox}
                        >
                            <Grid className={classes.formInput}>
                                <FormInput
                                    form={form}
                                    fullWidth
                                    isRequired={false}
                                    type="number"
                                    label={intl.formatMessage({ id: 'Settings.tracking.label' })}
                                    formItemKey="tracking.sampleRate"
                                    initialValue={get(metadata, 'tracking.sampleRate')}
                                />
                            </Grid>

                            <Grid className={classes.formInput}>
                                <FormInput
                                    form={form}
                                    fullWidth
                                    isRequired={false}
                                    type="number"
                                    label={intl.formatMessage({ id: 'Settings.tracking.label2' })}
                                    formItemKey="tracking.batchInterval"
                                    initialValue={get(metadata, 'tracking.batchInterval')}
                                />
                            </Grid>

                            <Grid className={classes.formInput}>
                                <FormInput
                                    form={form}
                                    fullWidth={false}
                                    isRequired={false}
                                    type="text"
                                    formItemKey="tracking.schedule"
                                    placeholder={intl.formatMessage({ id: 'Settings.tracking.label3' })}
                                    initialValue={get(metadata, 'tracking.schedule', '')}
                                />
                            </Grid>
                        </Grid>

                        <Grid container direction="column">
                            <Grid item>
                                <Typography variant="subtitle1" className={classes.title2}>
                                    <FormattedMessage
                                        id="Settings.tracking.whitelist"
                                        defaultMessage="URL whitelist"
                                    />
                                </Typography>
                            </Grid>

                            <Grid container direction="row" alignItems="flex-end">
                                <Grid className={classes.formInput}>
                                    <FormInput
                                        fullWidth={false}
                                        form={form}
                                        type="text"
                                        formItemKey="tracking.pattern"
                                        placeholder={intl.formatMessage({
                                            id: 'Settings.tracking.label4',
                                        })}
                                    />
                                </Grid>

                                <Typography variant="button">
                                    <Button
                                        id="yeself-button"
                                        variant="contained"
                                        color="primary"
                                        onClick={this.handleAddRow}
                                        className={classes.btnAdd}
                                        disabled={!getFieldValue('tracking.pattern')}
                                    >
                                        <FormattedMessage id="Buttons.add" defaultMessage="Add" />
                                    </Button>
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid container className={classes.boxList}>
                            <List className={classes.listItems}>
                                {getFieldValue('patterns') &&
                                    getFieldValue('patterns').map((item) => (
                                        <ListItem key={item} className={classes.listItem}>
                                            <ListItemText value={item} primary={item} />

                                            <ListItemIcon>
                                                <IconButton
                                                    className={classes.deleteBtn}
                                                    aria-label="Delete"
                                                    onClick={() => this.handleRemoveItem(item)}
                                                >
                                                    <CancelPresentation />
                                                </IconButton>
                                            </ListItemIcon>
                                        </ListItem>
                                    ))}
                            </List>
                        </Grid>

                        <Grid item>
                            <Typography variant="subtitle1" className={classes.title}>
                                <FormattedMessage
                                    id="Settings.tracking.events"
                                    defaultMessage="Tracked events"
                                />
                            </Typography>
                        </Grid>

                        <Grid container>
                            <Paper className={classes.paper}>
                                <Table className={classes.table}>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>
                                                <FormattedMessage
                                                    id="Settings.tracking.event.click"
                                                    defaultMessage="click"
                                                />
                                            </TableCell>
                                            <TableCell className={classes.tableItem}>
                                                <FormItemSwitch
                                                    initialValue={get(metadata, 'tracking.events.click')}
                                                    form={form}
                                                    formItemKey="tracking.events.click"
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FormattedMessage
                                                    id="Settings.tracking.event.mousemove"
                                                    defaultMessage="mousemove"
                                                />
                                            </TableCell>
                                            <TableCell className={classes.tableItem}>
                                                <FormItemSwitch
                                                    initialValue={get(
                                                        metadata,
                                                        'tracking.events.mousemove'
                                                    )}
                                                    form={form}
                                                    formItemKey="tracking.events.mousemove"
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FormattedMessage
                                                    id="Settings.tracking.event.scroll"
                                                    defaultMessage="scroll"
                                                />
                                            </TableCell>
                                            <TableCell className={classes.tableItem}>
                                                <FormItemSwitch
                                                    initialValue={get(
                                                        metadata,
                                                        'tracking.events.scroll'
                                                    )}
                                                    form={form}
                                                    formItemKey="tracking.events.scroll"
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FormattedMessage
                                                    id="Settings.tracking.event.mousedown"
                                                    defaultMessage="mousedown"
                                                />
                                            </TableCell>
                                            <TableCell className={classes.tableItem}>
                                                <FormItemSwitch
                                                    initialValue={get(
                                                        metadata,
                                                        'tracking.events.mousedown'
                                                    )}
                                                    form={form}
                                                    formItemKey="tracking.events.mousedown"
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FormattedMessage
                                                    id="Settings.tracking.event.mouseup"
                                                    defaultMessage="mouseup"
                                                />
                                            </TableCell>
                                            <TableCell className={classes.tableItem}>
                                                <FormItemSwitch
                                                    initialValue={get(
                                                        metadata,
                                                        'tracking.events.mouseup'
                                                    )}
                                                    form={form}
                                                    formItemKey="tracking.events.mouseup"
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FormattedMessage
                                                    id="Settings.tracking.event.keydown"
                                                    defaultMessage="keydown"
                                                />
                                            </TableCell>
                                            <TableCell className={classes.tableItem}>
                                                <FormItemSwitch
                                                    initialValue={get(
                                                        metadata,
                                                        'tracking.events.keydown'
                                                    )}
                                                    form={form}
                                                    formItemKey="tracking.events.keydown"
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FormattedMessage
                                                    id="Settings.tracking.event.keyup"
                                                    defaultMessage="keyup"
                                                />
                                            </TableCell>
                                            <TableCell className={classes.tableItem}>
                                                <FormItemSwitch
                                                    initialValue={get(metadata, 'tracking.events.keyup')}
                                                    form={form}
                                                    formItemKey="tracking.events.keyup"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Paper>
                        </Grid>
                    </>
                )}

                <Grid container alignItems="center">
                    <Typography variant="button">
                        <Button
                            id="yeself-button"
                            variant="contained"
                            color="primary"
                            onClick={this.handleSaveSettings}
                            className={classes.btn}
                        >
                            <FormattedMessage id="Buttons.save" defaultMessage="Save" />
                        </Button>
                    </Typography>
                </Grid>
            </Grid>
        );
    }
}

export default connect(
    (state) => ({
        metadata: selectApplicationMetaData(state),
    }),
    { updateDetailSettings }
)(withStyles(styles)(injectIntl(Tracking)));
